<template>
  <div class="banner__stat">
    <Image :source="content.icon" class="banner__stat-icon"/>
    <p>{{ content.text }}</p>
  </div>
</template>

<script>
import {Image} from '@/components/global'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'BannerStat',
  mixins: [HasContentMixin],
  components: {Image}
}
</script>